// import axios from 'axios';
import $http from '../plugins/axios';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getApi = async (url: string) => {
  const res = await $http.get(url);
  return res;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const postApi = async (url, param) => {
  const res = await $http.post(url, param);
  return res;
};
